import React from 'react'
// import Wosendernav from './Wosendernav'
import Wosenderaboutenable from './Wosenderaboutenenable'
import Helpingbusiness from './Helpingbusiness'
import Whattwedocontent from './Whattwedocontent'
import Whatsappautomation from './Whatsappautomation'
import Footer from './Footer'
import FAQ from './FAQ'
import GetStartedNow from './GetStartedNow'
import Whatsapp from './Whatsapp'
import Growsmarter from './Growsmarter'
import WhatwedoWhatsapp from './WhatwedoWhatsapp'
import Whatsappautomate from './Whatsappautomate'
import Navbar from './Navbar'

const WhatsappCampaign = () => {
  return (
    <>
  <Navbar/>
    <Whatsapp/>
    <Growsmarter/>
    <WhatwedoWhatsapp/>
    <Whatsappautomate/>
    <FAQ/>
    <GetStartedNow/>
   <Footer/>
    </>
  )
}

export default WhatsappCampaign